import { useEffect, useMemo, useState } from "react";


export const DEFAULT_PAGE_SIZE = 20;

export function usePagination(items, { pageSize = DEFAULT_PAGE_SIZE, resetKey = "" } = {}) {
  const [page, setPage] = useState(1);
  const totalItems = items.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const currentPage = Math.min(page, totalPages);
  const startIndex = (currentPage - 1) * pageSize;

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const paginatedItems = useMemo(
    () => items.slice(startIndex, startIndex + pageSize),
    [items, pageSize, startIndex]
  );

  const goToPage = (nextPage) => {
    setPage(Math.max(1, Math.min(nextPage, totalPages)));
  };

  return {
    page: currentPage,
    pageSize,
    totalItems,
    totalPages,
    startIndex,
    paginatedItems,
    goToPage,
  };
}
